interface CustomerBillingAbility {
  can?: (action: string, subject: string, field?: string) => boolean
}

export function canManageCustomerBilling(
  ability: CustomerBillingAbility | null | undefined
): boolean {
  return Boolean(
    ability?.can?.('manage', 'all') || ability?.can?.('manage', 'customers', 'billing')
  )
}

export function canViewCustomerReceivables(
  ability: CustomerBillingAbility | null | undefined
): boolean {
  return Boolean(ability?.can?.('access', 'global') || canManageCustomerBilling(ability))
}
